import { render, staticRenderFns } from "./couponView.vue?vue&type=template&id=e6249cc0&scoped=true&"
import script from "./couponView.vue?vue&type=script&lang=js&"
export * from "./couponView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6249cc0",
  null
  
)

export default component.exports